import { Inject, Injectable } from '@angular/core';
import { ApiService, TemplateParser, TEMPLATE_PARSER } from '@mode/shared/util-halogen';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { toMetric } from '../data-mappers/metric-data-mappers';
import { MetricResource } from '../metrics/metric-response.types';

@Injectable({ providedIn: 'root' })
export class MetricDimensionClientService {
  private readonly _metricEntry = this.urlTemplateService.parse('/api/{username}/dbt_metrics/{metricToken}');

  constructor(
    private apiService: ApiService,
    @Inject(TEMPLATE_PARSER) private urlTemplateService: TemplateParser
  ) {}

  getDimensions(username: string, metricToken: string) {
    return from(
      this.apiService.getFromPath<MetricResource>(this._metricEntry.expand({ username, metricToken }), {
        includes: 'metric_attrs',
      })
    ).pipe(
      map((resource) => toMetric(resource)),
      map((metric) => metric.attrs)
    );
  }
}
